import styled from 'styled-components';

export default styled.div`
  padding: 30px 0;
  &.empty {
    padding: 15px 0 15px 0;
  }

  & ~ & {
    padding-top: 0;
  }

  .heading-block {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding-bottom: 15px;
      .separator {
        border-radius: 2px;
        background-color: #d9d8dd;
        height: 1px;
        width: 100%;
      }
      p {
        min-width: fit-content;
        padding-right: 20px;
      }
    }
`;
